import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=e1c389e0&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"
import style0 from "./Image.vue?vue&type=style&index=0&id=e1c389e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c389e0",
  null
  
)

export default component.exports